const sseConstants = {
  ENDPOINT:
    process.env.REACT_APP_SSE_APP_ENDPOINT ||
    'http://localhost:8082/stream/events'
};

export enum SseEventType {
  BID_EVENT = 'BidEvent',
  ACTIVE_PROXY_BID_EVENT = 'ActiveProxyBidEvent',
  UPCOMING_PROXY_BID_EVENT = 'UpcomingProxyBidEvent'
}

export default sseConstants;
